import { ShieldCheck, ArrowLeft } from "lucide-react";
import { Logo } from "@/components/site/Logo";

const TERMS = [
  {
    title: "1. License grant",
    body: "Start-A-TE grants you (the \"Member\") a non-exclusive, non-transferable license to operate one traffic exchange website using the Start-A-TE software associated with your unique license number. The license is tied to your account and may not be resold, sublicensed or transferred to another party.",
  },
  {
    title: "2. Hosting & domain requirement",
    body: "The software and the domain name provided or used with it must remain hosted on the Start-A-TE hosting platform for the lifetime of the license. The software may not be moved, copied, mirrored or deployed to any third-party server, hosting provider or infrastructure outside of the Start-A-TE platform.",
  },
  {
    title: "3. Ownership of source code",
    body: "All source code, underlying software, designs and intellectual property remain the sole and exclusive property of the administrator (Start-A-TE). Purchase of a license grants a right to use the software as a hosted service only; it does not transfer ownership of, or any rights to, the source code to the Member or buyer.",
  },
  {
    title: "4. Permitted use",
    body: "You may configure branding, member settings, credit rates and content within the tools provided in your admin area. You may not decompile, reverse engineer, extract, redistribute or attempt to obtain the underlying source code of the software.",
  },
  {
    title: "5. Changes, features & customization",
    body: "Only Start-A-TE may change the domain, add new features, or customize the software. Any such change, feature addition or customization is performed exclusively by Start-A-TE and is subject to an additional fee agreed in advance. The Member may not make or commission these changes through any other party.",
  },
  {
    title: "6. Termination",
    body: "Violation of these terms — including moving the software or domain off the Start-A-TE hosting platform, or attempting to copy or claim ownership of the source code — may result in suspension or termination of the license without refund.",
  },
  {
    title: "7. One-time payment",
    body: "The license is provided for a single one-time payment with no recurring fees. Free installation, domain and lifetime hosting are included as part of the hosted service, subject to these terms. Optional domain changes, new features and customizations are charged separately as described in section 5.",
  },
];

export default function LicenseTerms() {
  return (
    <div className="min-h-screen bg-white" data-testid="license-terms-page">
      <header className="border-b border-slate-200">
        <div className="mx-auto flex max-w-4xl items-center justify-between px-5 py-4 lg:px-8">
          <Logo testId="license-terms-logo" small />
          <a href="/" className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-700 hover:text-blue-600" data-testid="license-terms-back"><ArrowLeft className="h-4 w-4" /> Back to site</a>
        </div>
      </header>
      <main className="mx-auto max-w-4xl px-5 py-14 lg:px-8">
        <div className="flex items-center gap-2 text-blue-600"><ShieldCheck className="h-6 w-6" /><span className="font-mono-x text-xs font-bold uppercase tracking-widest">Legal</span></div>
        <h1 className="font-display mt-4 text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">Start-A-TE Software — License Terms</h1>
        <p className="mt-4 max-w-2xl text-slate-600">These terms govern your use of the Start-A-TE traffic exchange software and your license number. By using the software you agree to the terms below.</p>

        <div className="mt-10 space-y-8">
          {TERMS.map((t) => (
            <section key={t.title} data-testid={`license-term-${t.title.split(".")[0]}`}>
              <h2 className="font-display text-lg font-bold text-slate-900">{t.title}</h2>
              <p className="mt-2 leading-relaxed text-slate-700">{t.body}</p>
            </section>
          ))}
        </div>

        <div className="mt-12 rounded-2xl border border-blue-200 bg-blue-50 p-6">
          <p className="text-sm font-semibold text-slate-700">In short: the software and domain must stay on the Start-A-TE hosting platform, the source code remains the property of the administrator and is not transferred to the buyer, and only Start-A-TE can change the domain, add features or customize the software for an additional fee.</p>
        </div>
      </main>
    </div>
  );
}
